import React from "react"
import ReactModal from "react-modal"
import { AnimatePresence, motion } from "framer-motion"
import classnames from "classnames"

ReactModal.defaultStyles = {}

try {
  if (window && window.document && window.document.createElement) {
    ReactModal.setAppElement(document.getElementById("___gatsby"))
  }
} catch (e) {}

export default function Modal({
  className,
  open,
  onRequestClose,
  contentLabel,
  children,
  ...props
}) {
  return (
    <ReactModal
      isOpen={open}
      onRequestClose={onRequestClose}
      contentLabel={contentLabel}
      overlayClassName="overlay fixed inset-0 flex items-center justify-center p-4 z-50"
      className="w-full max-w-screen-md flex items-center justify-center outline-none"
      closeTimeoutMS={300}
      {...props}
    >
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ scale: 0.8, y: 100, opacity: 0 }}
            animate={{ scale: 1, y: 0, opacity: 1 }}
            exit={{ scale: 0.8, y: 100, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className={classnames(
              "w-full shadow-xl rounded overflow-hidden bg-white",
              className
            )}
          >
            {children}
          </motion.div>
        )}
      </AnimatePresence>
    </ReactModal>
  )
}
